var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset26(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 656 650.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ae6c73;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29,359.32S-24,92.52,156,42.52s529.71-143,466.36,326l-58.36,67S409-213.87,29,359.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29,359.32l31.7,59.8S81.27,279,118.63,241.27L51.2,219.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29,359.32s-56.22,66.79-12.11,102.49c0,0-31.89,54.24-2.39,89.48,0,0-30.06,35,7.22,63.64,0,0,33.28-15.41,16.28-56.41,0,0,49.18-49.41,6.59-96.71,0,0,49.29-35.6,23.85-85.45S29,359.32,29,359.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M619,364.36S690.7,439,634.46,478.91c0,0,40.66,60.62,3,100,0,0,38.33,39.16-9.2,71.12,0,0-42.44-17.22-20.76-63,0,0-62.72-55.22-8.41-108.08,0,0-62.86-39.8-30.41-95.51S619,364.36,619,364.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.07,119.26s-68.93,14.81-61.5,89.54c0,0,83.39-1.8,85.41-89.54S307.07,119.26,307.07,119.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335.49,119.71s68.92,14.81,61.5,89.53c0,0-83.4-1.79-85.41-89.53S335.49,119.71,335.49,119.71Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset26);
export default __webpack_public_path__ + "static/media/Asset 26.d5d8b6e4.svg";
export { ForwardRef as ReactComponent };